module.exports = __webpack_public_path__ + "static/assets/807382b3f60d8eeebb10875a243c6bf8.gif";